<template>
  <footer class="mobility-footer">
    <div class="top-links">
      <div class="teq-container">
        <div class="top-link">
          <svg class="icon">
            <use
              xlink:href="#icon-location-white"
            ></use>
          </svg>
          <div class="top-link-title">
            <strong>Plus de 500 agences </strong>de proximité
          </div>
        </div>
        <div class="top-link">
          <svg class="icon">
            <use
              xlink:href="#icon-electric-cars"
            ></use>
          </svg>
          <div class="top-link-title">
            <strong>Premier loueur <br>de véhicules électriques </strong>en France
          </div>
        </div>
        <div class="top-link">
          <svg class="icon">
            <use
              xlink:href="#icon-badge"
            ></use>
          </svg>
          <div class="top-link-title">
            <strong>Roulez confiant </strong>avec les garanties Renault
          </div>
        </div>
        <div class="top-link">
          <svg class="icon">
            <use
              xlink:href="#icon-configuration"
            ></use>
          </svg>
          <div class="top-link-title">
            <strong>Facilitez votre quotidien </strong>avec Mobilize Share
          </div>
        </div>
      </div>
    </div>
    <div class="center-links">
      <div class="teq-container">
        <div
          class="column"
          @click="toggle(0)"
          :class="{'active': columnStates[0]}"
        >
          <div class="center-link-title-container">
            <div class="center-link-title">
              Service client
              <svg class="icon-arrow">
                <use xlink:href="#icon-arrow2"></use>
              </svg>
            </div>
          </div>
          <div class="center-link-container">
            <a
              class="center-link"
              href="/contact"
            >Contactez-nous</a>
            <a
              class="center-link"
              href="/agences"
            >Nos agences</a>
            <a
              class="center-link"
              href="/faq"
            >FAQ : Foire aux questions</a>
          </div>
        </div>
        <div
          class="column"
          @click="toggle(1)"
          :class="{active: columnStates[1]}"
        >
          <div class="center-link-title-container">
            <div class="center-link-title">
              Liens directs
              <svg class="icon-arrow">
                <use xlink:href="#icon-arrow2"></use>
              </svg>
            </div>
          </div>
          <div class="center-link-container">
            <a
              class="center-link"
              target="_blank"
              href="https://www.mobilize.fr/offres.html"
            >Les offres de mobilités Mobilize</a>
            <a
              class="center-link"
              target="_blank"
              href="https://www.renault.fr/"
            >Renault</a>
            <a
              class="center-link"
              href="/"
            >Réserver un véhicule</a>
            <a
              class="center-link"
              href="/location-en-agence"
            >Location en agence </a>
            <a
              class="center-link"
              href="/libre-service"
            >Libre service   </a>
            <a
              class="center-link"
              href="/vehicules"
            >Nos véhicules par gamme</a>
          </div>
        </div>
        <div
          class="column"
        >
          <div class="center-link-title-container">
            <div class="center-link-title">
              Découvrez le libre service
            </div>
          </div>
          <a
            class="app-link"
            href="https://t.rnlt.fr/ex9v0wi1bp"
            target="_blank"
          ><img
            class="app-icon"
            alt="logo"
            src="../../../../assets/images/googleplay.svg"
          ></a>
          <a
            class="app-link"
            href="https://t.rnlt.fr/avxx795qf0"
            target="_blank"
          ><img
            class="app-icon"
            alt="logo"
            src="../../../../assets/images/app-store.svg"
          ></a>
        </div>
      </div>
    </div>
    <div class="bottom-links">
      <div class="teq-container">
        <div class="left">
          <a
            href="/informations-legales"
            class="bottom-link"
          >
            Informations légales
          </a>
          <a
            href="/donnees-personnelles"
            class="bottom-link"
          >
            Données personnelles
          </a>
          <a
            href="/cookies"
            class="bottom-link"
          >
            Cookies
          </a>
          <a
            href="/conditions-generales"
            class="bottom-link"
          >
            Conditions générales de location
          </a>
        </div>
        <div class="right">
          <div
            class="copyright"
          >
            © Mobilize Share 2021
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MobilityFooter',
  computed: {
    footer() {
      return [...window.renaultMobility.footer]
    },
  },
  data() {
    return {
      columnStates: [
        false,
        false,
        false,
        false,
      ],
    }
  },
  methods: {
    setUrl(val) {
      return val || '#0'
    },
    toggle(idx) {
      const columnStates = [...this.columnStates]
      columnStates[idx] = !columnStates[idx]
      this.columnStates = columnStates
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../_src/sass/config/vars";
@import "../../../../_src/sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

.mobility-footer {
  box-sizing: border-box;
}

.top-links {
  background: black;
  cursor: pointer;

  .teq-container {
    @include teq-breakpoint($large) {
      max-width: 105rem;
    }
  }
}

.teq-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 4.8rem 0 1rem;

  @include teq-breakpoint($large) {
    padding: 2.8rem 0 0;
  }
}

.top-link {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  width: calc(50% - 1.5rem);

  @include teq-breakpoint($large) {
    margin-bottom: 2rem;
    max-width: 18rem;
    width: calc(25% - 1.5rem);
  }

  &:first-child {
    margin-bottom: 5rem;

    @include teq-breakpoint($large) {
      margin-bottom: 0;
    }

    .icon {
      height: 3.2rem;
      width: 2.5rem;
    }
  }

  &:nth-child(2) {
    margin-bottom: 5rem;

    @include teq-breakpoint($large) {
      margin-bottom: 0;
    }

    .icon {
      height: 3.3rem;
      width: 5rem;
    }
  }

  &:nth-child(3) {
    .icon {
      height: 3.2rem;
      width: 2.6rem;
    }
  }

  &:nth-child(4) {
    .icon {
      height: 3.3rem;
      width: 3.3rem;

      @include teq-breakpoint($large) {
        height: 3.5rem;
        width: 3.5rem;
      }
    }
  }
}

.center-link-container {
  display: flex;
  flex-direction: column;
  height: 0;
  overflow: hidden;
  transition: 0.4s;
  width: 100%;

  @include teq-breakpoint($large) {
    height: auto;
    max-width: 18rem;
    width: calc(25% - 1.5rem);
  }
}

.icon {
  display: block;
  fill: white;
  height: 3.5rem;
  margin: 0 auto 2.2rem;
}

.center-links {
  @include teq-breakpoint($large) {
    display: flex;
  }
}

.top-link-title {
  color: #fff;
  font-family: $f-graphie-book;
  font-size: 1.4rem;
  line-height: 2.24rem;
  margin-bottom: 1rem;
  text-align: center;

  strong {
    display: block;
    font-family: $f-graphie-semibold;
    font-size: 1.7rem;
    line-height: 2.56rem;
    margin-bottom: 0.8rem;
  }
}

.column {
  cursor: pointer;
  margin-bottom: 2.5rem;
  width: 100%;

  @include teq-breakpoint($large) {
    cursor: auto;
    max-width: 18rem;
    width: calc(25% - 1.5rem);
  }

  &.active {
    .center-link-container {
      height: auto;
    }

    .icon-arrow {
      transform: rotate(-90deg);
    }
  }
}

.center-link-title-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 1.2rem;
  justify-content: space-between;
  line-height: 1.6rem;
  margin-bottom: 1rem;
  pointer-events: auto;
  width: 100%;

  @include teq-breakpoint($large) {
    margin-bottom: 1rem;
  }
}

.center-link-container {
  width: 100%;
}

.center-link-title {
  color: #000;
  display: flex;
  font-family: $f-graphie-semibold;
  font-size: 1.2rem;
  justify-content: space-between;
  line-height: 1.6rem;
  //text-transform: uppercase;
  width: 100%;
}

.center-link {
  color: #000;
  cursor: pointer;
  font-family: $f-graphie-book;
  font-size: 1.2rem;
  line-height: 3rem;

  @include teq-breakpoint($large) {
    line-height: 2rem;
  }
}

.icon-arrow {
  display: inline-block;
  fill: #000;
  height: 1.3rem;
  transform: rotate(90deg);
  transition: 0.4s;
  width: 0.8rem;

  @include teq-breakpoint($large) {
    display: none;
  }
}

.icon-container {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
  max-width: 16.6rem;
  width: 100%;

  @include teq-breakpoint($large) {
    margin-top: 2rem;
  }
}

.social-link {
  cursor: pointer;
  height: 3rem;
  width: 3rem;
}

.app-link {
  display: inline-block;
  height: auto;
  margin-top: 1rem;
}

.app-icon {
  display: inline-block;
  height: 3.9rem;

  &:first-child {
    margin-right: 1.5rem;
    width: 12.9rem;
  }

  &:nth-child(2) {
    width: 12.9rem;
  }

  @include teq-breakpoint($large) {
    &:first-child,
    &:nth-child(2) {
      height: 3.7rem;
      margin-right: 0;
      width: 12.3rem;
    }
  }
}

.bottom-links {
  border-top: 1px solid #c4c4c4;

  @include teq-breakpoint($large) {
    border-top: none;
  }

  .teq-container {
    flex-direction: column;
    padding: 3.5rem 0;

    @include teq-breakpoint($large) {
      border-top: 1px solid #c4c4c4;
      flex-direction: row;
      padding: 2rem 0;
    }
  }
}

.bottom-link {
  color: #222;
  cursor: pointer;
  display: block;
  font-family: $f-graphie-book;
  font-size: 1.2rem;
  line-height: 1.5rem;
  margin-bottom: 2rem;
  overflow: visible;
  position: relative;

  @include teq-breakpoint($large) {
    display: flex;
    margin: 0 3rem 0 0;

    &::before {
      background: #ddd;
      content: '';
      height: 1.4rem;
      position: absolute;
      right: -1.5rem;
      top: 0;
      width: 2px;
    }

    &:last-child {
      &::before {
        background: none;
      }
    }
  }
}

.left,
.right {
  width: 100%;
}

.left {
  @include teq-breakpoint($large) {
    display: flex;
    width: calc(100% - 23rem);
  }
}

.right {
  @include teq-breakpoint($large) {
    text-align: right;
    width: 23rem;
  }
}

.copyright {
  color: #000;
  font-family: $f-graphie-book;
  font-size: 1.2rem;
  line-height: 4rem;

  @include teq-breakpoint($large) {
    line-height: 1.5rem;
  }
}

</style>
